import React from "react";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Api } from "../app-controller.js";

class DenunciasPublicas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    let grid = {
      source: "app/getDenunciasPublicas",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      hidePager: true, //Oculta el paginador
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        nom_documento: {
          label: "Nombre",
        },
      },
      buttons: [
        {
          iconClass: "fas fa-file-download",
          btnClass: "btn btn-success",
          buttonAreaClasses: "60px",
          download: "download",
          btnClick: (data) => {
            window.location.href =
              Api.url + `app/documentoDenuncia/?id=${data.id}&download=1`;
          },
          render: (me, data) => {},
        },
      ],
    };
    let mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      onchange: (me, data, serial) => {
        mi_grid.go(1, serial);
      },
      render: (form) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "nom_documento",
            label: "Nombre del documento:",
            placeHolder: "Nombre del documento",
            cols: 12,
            value: "",
          },
        },
      ],
    });
  }

  render() {
    return (
      <div className="login login-v1">
        <div className="login-container">
          <div id="header" className="header navbar-default">
            <img
              className="logo"
              alt="Logo"
              style={{ width: "2.8%" }}
              src="../favicon.ico"
            ></img>
            <h1>
              <b>SINAIP</b>
            </h1>
          </div>
          <Panel>
            <PanelBody>
              <h1 className="page-header">Denuncias públicas</h1>
              <div className="row">
                <div className="col-sm-12">
                  <fieldset>
                    <div id="busqueda"></div>
                  </fieldset>
                  <div id="myGrid"></div>
                </div>
              </div>
              <hr></hr>
              <div className="col-sm-12">
                <a href="/">
                  <button className="btn btn-block btn-lg btn-primary">
                    Regresar
                  </button>
                </a>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>
    );
  }
}
export default DenunciasPublicas;
